import { bridgeApi } from '../network'

export async function saveAdvisorDetails(suppliedData) {
  const { data } = await bridgeApi.post(
    '/enterprise/subAgent/saveDetails',
    suppliedData
  )
  return data
}

export async function updateFreshChatId(id) {
  const { data } = await bridgeApi.post(
    '/enterprise/subAgent/updateFreshChatId',
    { id: id }
  )
  return data
}
